export default __webpack_public_path__ + "5e44c5b9562a808c8f909da9cf3a4158.png";